
export class DialogMessage {

  constructor(public type: string,
              public message: any) {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/dialog-messages/dialog-message.model.ts